/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-curly-newline */
/*eslint-disable*/

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import './Sidebar.scss';

export const AuthenticatedRouteWithoutSidebar = ({ component: Component, ...rest }) => {
  const cleanSearch = window.location.search.replace(/\/(?=\?|$)/g, '');

  return (
    <>
      <div className=''>
        <Route
          {...rest}
          render={(props) =>
            JSON.parse(localStorage.getItem('state')).userProfile.token ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{ pathname: '/preload', search: cleanSearch, state: { from: props.location } }}
              />
            )
          }
        />
      </div>
    </>
  );
};
